/**
 * Support Redux Selectors
 */

import { createSelector } from '@reduxjs/toolkit'
import type { SupportState } from './support.slice'

interface RootState {
  support: SupportState
}

export const selectSupportState = (state: RootState) => state.support
export const selectSupportTickets = (state: RootState) => state.support.items
export const selectSelectedTicket = (state: RootState) => state.support.selectedTicket
export const selectSupportStats = (state: RootState) => state.support.stats
export const selectSupportFilter = (state: RootState) => state.support.filter
export const selectSupportLoading = (state: RootState) => state.support.loading
export const selectSupportError = (state: RootState) => state.support.error
export const selectSupportPaginationRaw = (state: RootState) => state.support.pagination

export const selectSupportPagination = createSelector(
  [selectSupportPaginationRaw, selectSupportFilter],
  (pagination, filter) => ({
    ...pagination,
    page: filter.page ?? 1,
    pageSize: filter.pageSize ?? pagination.pageSize,
  })
)

export const selectFilteredTickets = createSelector(
  [selectSupportTickets],
  (tickets) => tickets
)
